import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import List, { Theme as ListTheme } from 'components/base/List'
import Link from 'components/base/Link'

import YouTube from 'components/blocks/YouTube'
import FeaturedNews from 'components/blocks/FeaturedNews'
import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import Connect from 'components/blocks/Connect'
import Leadership from 'components/blocks/Leadership'
import OurStory from 'components/blocks/OurStory'

import VideoTop from './styles'

const AboutUsScreen: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='About | Insurance Lounge'
      description='Insurance Lounge is committed to bringing simplicity to insurance. Our personalized concierge service makes home, auto, life, health, & other insurance easy.'
      ogImg='/images/og-images/About.webp'
      schema={{
        '@context': 'http://schema.org',
        '@type': 'VideoObject',
        name: 'Insurance Lounge | Our Founder’s Story | Insurance Lounge',
        description: 'Our Founder Michael DeLaGrange explains how he got into the insurance industry and how/why Insurance Lounge was created! Insurance Lounge is the culmination of an idea whose sole purpose is making Insurance easier to purchase and understand for consumers. With a heavy emphasis on technology and simplicity, Insurance Lounge will pave a new way for consumers to interact online and in our storefronts by creating a truly interactive Insurance experience.',
        transcript: 'I’m Michael D LaGrange president and CEO of insurance Lounge I have a very interesting story of how I got involved in insurance I grew up with my father owning a small agency here in Grants Pass Oregon and I was around the office a lot but I really never expected to get into Insurance you don’t grow up as a young kid you know dreaming of being an insurance agent or running an insurance business I actually had a dream of playing professional football growing up I was lucky enough to go play at the University of Oregon have a pretty successful career there but two weeks after my last football game my senior year at Oregon I got the call that no one wants to get and my dad passed away unexpectedly I was faced with the decision of either following my dream and playing in the NFL or moving back home and making sure our family business could stay open in a rally for me it was never a choice if I was going to move home and help my mom and my brother keep the family business open thrown into the insurance world even though I grew up in it didn’t have a lot of experience or knowledge but looking back it’s probably the best thing could have happened to me because it was a great introduction into a very stable industry that I’ve really learned to love and respect today after moving back home and help my family keep the family business open back in 2005 we grew the insurance agency two or three times the size of it was initially and I honestly got bored with insurance insurance isn’t the most exciting business to be in that was a challenge to me it wasn’t an obstacle that I was going to shy away from I decided to create an environment that made Insurance fun and more accessible and easy for the consumer to access it and that is how I came up with insurance Lounge the whole Insurance Lounge concept all evolved out of frustrations of what I saw in the industry I try to come up with a hybrid that included the Online Marketplace for insurance and the traditional agency and blend them together creating a hybrid between the Online Marketplace for insurance and the brick and mortar Insurance Agency was the goal for insurance it was to create competitive advantages that don’t currently exist in a single format Insurance Lounge created some competitive advantages that no other format has we’re open seven days a week so the consumer can come in before work after work on the weekends whenever is convenient for them we also created an atmosphere where the consumer can shop for any type of insurance in one place we have access to over 100 different carriers to shop their best rates and plans to make sure you get the best deal and best coverage there is available at Insurance Lounge we have created the next wave of how people are going to purchase insurance now and into the future the insurance industry isn’t innovating at a that most other large businesses are so I’m glad that insurance Lounge is on the Forefront of innovation and can take this industry into the next century.',
        thumbnailUrl: 'https://i.ytimg.com/vi/MxbkCJQ9I3w/default.jpg',
        uploadDate: '2023-04-20T17:18:18Z',
        duration: 'PT2M53S',
        embedUrl: 'https://www.youtube.com/embed/MxbkCJQ9I3w',
        interactionCount: '993',
      }}
    />
    <PageHero theme={PageHeroTheme.about}>The Insurance Lounge Difference</PageHero>
    <Content short={true} center={true} margined={true}>
      <Paragraph theme={ParagraphTheme.introLarge}>
        At Insurance Lounge, we are committed to bringing simplicity back to insurance.
        By focusing on innovation and technology, we believe we can make purchasing insurance more fun, efficient,
        and convenient.
      </Paragraph>
    </Content>
    <Content margined={true}>
      <VideoTop>
        <YouTube youtubeId='MxbkCJQ9I3w' />
      </VideoTop>
      <Content short={true} center={true}>
        <Title level={3}>
          Our Insurance Concierge service
        </Title>
        <Paragraph>Take a look inside the innovation behind our Insurance Concierge™ service
          and how it helps provide dedicated one-on-one attention to every Insurance Lounge customer,
          whether online, over the phone, or in person. Our technology creates opportunities to shop
          for insurance with ease across varied insurance needs.
        </Paragraph>
        <Paragraph>Our personal Insurance Concierge service is what distinguishes us from the competition,
          with core focuses on:
        </Paragraph>
        <List theme={ListTheme.large} clean={true} centerItems={true}>
          <li>Counseling</li>
          <li>Brokering</li>
          <li>Administrating</li>
        </List>
        <Paragraph>Our Insurance Concierge service also includes underwriting services to our online
          customers for products such as:
        </Paragraph>
        <List theme={ListTheme.large} clean={true} centerItems={true}>
          <li><Link to='/products/auto-insurance'>Auto insurance</Link></li>
          <li><Link to='/products/homeowners-insurance'>Home insurance</Link></li>
          <li><Link to='/products/life-insurance'>Life insurance</Link></li>
          <li><Link to='/products/health-insurance'>Health insurance</Link></li>
          <li><Link to='/products/disability-insurance'>Disability insurance</Link></li>
          <li><Link to='/products/investments-retirement'>Investment and retirement products</Link></li>
        </List>
        <Paragraph>
          Our Insurance Concierge service technology lets our online customers have a one-on-one customer
          service experience seven days a week. This service also allows our customers to save their
          quotes online and access them through email. In addition, customers can return to Insurance Lounge’s
          website to revise their quotes and add additional policies whenever convenient. Because our
          technology allows users to shop, purchase, and manage insurance policies in one place,
          our customers can enjoy the simplicity of adjusting policies at a one-stop shop.
          Insurance Lounge takes pride in being a no-commission insurance agency that puts
          our customers’ needs before our bottom line. Shop with us today to compare
          rates and plans from over 100 carriers.
        </Paragraph>
      </Content>
    </Content>
    <OurStory />
    <Leadership />
    <FeaturedNews />
    <Connect
      trackingInfo={{
        button_position: 'bottom',
        page_category: 'about_us',
      }}
    />
  </div>
)

export default AboutUsScreen
